
type Listener<T> = (args: T) => void;

export function safeInvokeListeners<T>(listeners: Set<Listener<T>>, args: T) {
    for (const listener of listeners) {
        try {
            listener(args);
        }
        catch (error) {
            console.error("Error invoking listener", error);
        }
    }
}